
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[language]/redirect-to-site",
      function () {
        return require("private-next-pages/[region]/[language]/redirect-to-site/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[language]/redirect-to-site"])
      });
    }
  